import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "components/atoms/BasicTable";
import Icon from "components/atoms/Icon/Icon";
import BulkItem from "components/modules/Bulk/Item/Item";
import { EnrichmentDTO } from "utils/dtos/enrichmentDTO";

const LeadHistoryBodyBulk: React.FC<{
  data: EnrichmentDTO[];
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
  isMobile: boolean;
  tableColumns: number;
}> = ({ data, isSuccess, errorMessage, isMobile, tableColumns }) => {
  const shouldShowEmptyState =
    !!errorMessage || (isSuccess && data.length === 0);

  if (shouldShowEmptyState) {
    return (
      <TableRow>
        <TableCell colspan={isMobile ? 2 : tableColumns}>
          <div className="flex flex-col items-center justify-center py-10">
            <Icon name="document" size={50} />
            <p className="text-lg mt-2">No Lists found</p>
          </div>
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      <TableHeader>
        <TableRow>
          <TableCell isHeader className="text-left w-[160px]">
            File Name
          </TableCell>
          <TableCell isHeader className="text-center">
            Leads
          </TableCell>
          <TableCell isHeader>Date & Time</TableCell>
          <TableCell isHeader className="w-[40px]">
            Actions
          </TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isSuccess &&
          data.map((item: EnrichmentDTO, i) => (
            <BulkItem index={i} data={item} key={item.enrichmentId} />
          ))}
      </TableBody>
    </>
  );
};

export default LeadHistoryBodyBulk;
